module.exports = __webpack_public_path__ + "static/media/clock.1e987f4c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clock.svg
// module id = 262
// module chunks = 0